import { createContext } from "react";
import {
  SortingTableContext as TableContext,
  SortingTableNoChecklistContext
} from "../../../../types/collections";

export const SortingTableContext = createContext(
  {} as TableContext | SortingTableNoChecklistContext
);
